(function () {
  if (window.__klipProductCardCouponLoaded) return;
  window.__klipProductCardCouponLoaded = true;

  const CARD_SELECTOR = '[data-klip-card-coupon]';
  const CODE_BLOCKLIST = new Set([
    'SAVE',
    'OFF',
    'FOR',
    'THIS',
    'PRODUCT',
    'COPY',
    'CODE',
    'COUPON',
    'DISCOUNT',
    'CHECKOUT',
    'GET',
    'USE',
    'THE',
    'USD',
  ]);

  function calculateDiscountedCents(originalCents, percent) {
    const discountCents = Math.floor((originalCents * percent) / 100);
    return Math.max(originalCents - discountCents, 0);
  }

  function initKlipCardCoupons(container = document) {
    container.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (card.dataset.klipCardCouponBound === 'true') return;
      card.dataset.klipCardCouponBound = 'true';

      if (card.classList.contains('is-active')) {
        updateNativePrice(card, shouldShowCoupon(card));
        return;
      }

      const collectionCoupon = findCouponInCollectionBox(card);
      if (collectionCoupon) {
        card.dataset.klipCardCouponStatus = 'collection-box';
        renderCoupon(card, collectionCoupon);
        return;
      }

      const cardCoupon = findCouponInCard(card);
      if (cardCoupon) {
        card.dataset.klipCardCouponStatus = 'card-source';
        renderCoupon(card, cardCoupon);
        return;
      }

      card.dataset.klipCardCouponStatus = 'waiting-for-collection-box';
      observeCollectionBox(card);
    });
  }

  function observeCollectionBox(card) {
    const source = card.querySelector('[data-klip-card-render-source]');
    if (!source || card.klipCardCouponObserver) return;

    card.klipCardCouponObserver = new MutationObserver(() => {
      if (card.classList.contains('is-active')) return;

      const coupon = findCouponInCollectionBox(card);
      if (!coupon) return;

      card.dataset.klipCardCouponStatus = 'collection-box';
      renderCoupon(card, coupon);
    });

    card.klipCardCouponObserver.observe(source, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });

    window.setTimeout(() => {
      const coupon = findCouponInCollectionBox(card);
      if (!coupon || card.classList.contains('is-active')) return;

      card.dataset.klipCardCouponStatus = 'collection-box-delayed';
      renderCoupon(card, coupon);
    }, 1200);
  }

  function findCouponInCollectionBox(card) {
    const source = card.querySelector('[data-klip-card-render-source]');
    if (!source) return null;

    const blocks = Array.from(source.querySelectorAll('.elsklip-coupon-box, [class*="klip"], [class*="coupon"]'));

    for (const block of blocks) {
      const coupon = parseCouponFromDataAttributes(block) || findCouponInBlock(block);
      if (coupon) return { ...coupon, source: 'collection-box' };
    }

    return parseCouponFromDataAttributes(source) || findCouponInBlock(source);
  }

  function parseCouponFromDataAttributes(element) {
    if (!element) return null;

    const code = getCodeFromAttributes(element);
    if (!code) return null;

    for (const attribute of Array.from(element.attributes || [])) {
      const value = attribute.value || '';
      if (!/%|percent|discount|coupon|save/i.test(`${attribute.name} ${value}`)) continue;

      const percent = extractPercent(value);
      if (!percent) continue;

      return {
        code,
        percent,
        text: value,
        source: 'collection-box-attribute',
      };
    }

    return null;
  }

  function findCouponInCard(card) {
    const root = card.closest('.seed-discount-product-card, .card-wrapper, .card');
    const appSource = root?.querySelector('[data-klip-card-app-source]');
    if (!appSource) return null;

    return findCouponInBlock(appSource);
  }

  function findCouponInBlock(block) {
    const blockText = getText(block);
    const blockPercent = extractPercent(blockText);
    const blockCode = blockPercent ? extractCode(block, block) : null;

    if (blockPercent && blockCode && blockText.length <= 900) {
      return {
        code: blockCode,
        percent: blockPercent,
        text: blockText,
        source: 'coupon-block-text',
      };
    }

    const buttons = Array.from(block.querySelectorAll('button, [role="button"], a, input[type="button"]'));

    for (const button of buttons) {
      const buttonText = getText(button);
      const buttonValue = button.value || '';
      const looksLikeCopyButton = /copy|coupon|code/i.test(`${buttonText} ${buttonValue}`);

      if (!looksLikeCopyButton) continue;

      const sourceElement = getCouponSource(block, button);
      if (!sourceElement) continue;

      const sourceText = getText(sourceElement);
      const percent = extractPercent(sourceText);
      const code = extractCode(sourceElement, button);

      if (!percent || !code) continue;

      return {
        code,
        percent,
        text: sourceText,
        source: 'coupon-copy-source',
      };
    }

    return null;
  }

  function getCouponSource(root, button) {
    let current = button.parentElement;
    let best = null;

    for (let depth = 0; current && current !== root && depth < 9; depth += 1) {
      const text = getText(current);

      if (/%/.test(text) && text.length <= 700) best = current;

      if (/%/.test(text) && /off|save|discount|coupon|code|product/i.test(text) && text.length <= 420) {
        return current;
      }

      current = current.parentElement;
    }

    return best;
  }

  function extractPercent(text) {
    const match = text.match(/(\d+(?:\.\d+)?)\s*%/);
    if (!match) return null;

    const percent = Number.parseFloat(match[1]);
    if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return null;

    return percent;
  }

  function extractCode(sourceElement, button) {
    const attributeCode = getCodeFromAttributes(button) || getCodeFromAttributes(sourceElement);
    if (attributeCode) return attributeCode;

    const codeElement = Array.from(sourceElement.querySelectorAll('[data-code], [data-coupon-code], [data-discount-code]'))
      .map((element) => getCodeFromAttributes(element))
      .find(Boolean);

    return codeElement || '';
  }

  function getCodeFromAttributes(element) {
    if (!element) return '';

    const attributes = [
      'data-code',
      'data-coupon-code',
      'data-discount-code',
      'data-clipboard-text',
      'data-clipboard-value',
    ];

    for (const attribute of attributes) {
      const value = element.getAttribute?.(attribute);
      const code = extractCodeFromString(value);
      if (code) return code;
    }

    return '';
  }

  function extractCodeFromString(value) {
    if (!value) return '';

    const tokens = String(value).match(/\b[A-Za-z0-9][A-Za-z0-9_-]{3,}\b/g) || [];
    return tokens.find((token) => !CODE_BLOCKLIST.has(token.toUpperCase())) || '';
  }

  function renderCoupon(card, coupon) {
    const originalCents = Number.parseInt(card.dataset.originalPriceCents || '0', 10);
    const percent = Number.parseFloat(coupon.percent || '0');
    const code = String(coupon.code || '').trim();
    const configuredCode = String(card.dataset.couponCode || '').trim();

    if (
      !Number.isFinite(originalCents) ||
      originalCents <= 0 ||
      !Number.isFinite(percent) ||
      percent <= 0 ||
      !code ||
      !configuredCode ||
      configuredCode.toUpperCase() !== code.toUpperCase()
    ) {
      hideCoupon(card);
      return;
    }

    const couponCents = calculateDiscountedCents(originalCents, percent);
    const badgeLabel = card.dataset.badgeLabel || '';
    const saveLabel = card.dataset.saveLabel || 'Save';
    const soldOutLabel = card.dataset.soldOutLabel || 'Sold out';
    const showSaveBadge = card.dataset.showSaveBadge !== 'false';
    const showCouponText = card.dataset.showCouponText === 'true';
    const currencyCode = card.dataset.currencyCode || window.Shopify?.currency?.active || 'USD';
    const soldOut = isSoldOut(card);

    setText(card.querySelector('[data-klip-card-coupon-price]'), coupon.saleText || formatMoney(couponCents, currencyCode));
    setText(
      card.querySelector('[data-klip-card-coupon-compare]'),
      coupon.compareText || formatMoney(originalCents, currencyCode)
    );

    const badge = card.querySelector('[data-klip-card-coupon-badge]');
    setText(badge, badgeLabel);
    if (badge) badge.hidden = !badgeLabel;

    const save = card.querySelector('[data-klip-card-coupon-save]');
    setText(save, soldOut ? soldOutLabel : `${saveLabel} ${formatPercent(percent)}`);
    if (save) {
      save.hidden = !showSaveBadge;
      save.classList.toggle('is-sold-out', soldOut);
      if (soldOut) {
        const compare = card.querySelector('[data-klip-card-coupon-compare]');
        compare?.insertAdjacentElement('afterend', save);
      }
    }

    const text = card.querySelector('[data-klip-card-coupon-text]');
    setText(text, code);
    if (text) text.hidden = !showCouponText || !text.textContent.trim();

    card.dataset.couponPercent = String(percent);
    card.hidden = false;
    card.classList.add('is-active');
    updateNativePrice(card, true);
  }

  function hideCoupon(card) {
    card.hidden = true;
    card.classList.remove('is-active');
    updateNativePrice(card, false);
  }

  function updateNativePrice(card, hasCoupon) {
    const seedPrice = card.closest('.seed-discount-product-card__info')?.querySelector('.seed-discount-product-card__price');
    if (seedPrice) {
      seedPrice.classList.toggle('has-klip-card-coupon', hasCoupon);
      return;
    }

    const predictivePrice = card.closest('.predictive-search__item-content')?.querySelector('.price');
    if (predictivePrice) {
      predictivePrice.classList.toggle('has-klip-card-coupon', hasCoupon);
      return;
    }

    const dawnPrice = card.parentElement?.querySelector(':scope > .price');
    if (dawnPrice) dawnPrice.classList.toggle('has-klip-card-coupon', hasCoupon);
  }

  function shouldShowCoupon(card) {
    return card.classList.contains('is-active') && !isSoldOut(card);
  }

  function isSoldOut(card) {
    const productCard = card.closest('[data-seed-discount-card]');
    return productCard?.dataset.variantSoldOut === 'true';
  }

  function setText(element, value) {
    if (element) element.textContent = value || '';
  }

  function formatPercent(percent) {
    return `${Number.isInteger(percent) ? percent : percent.toFixed(1)}%`;
  }

  function formatMoney(cents, currencyCode) {
    const amount = cents / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  }

  function getText(element) {
    return (element?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initKlipCardCoupons());
  } else {
    initKlipCardCoupons();
  }

  window.initKlipCardCoupons = initKlipCardCoupons;
  document.addEventListener('shopify:section:load', (event) => initKlipCardCoupons(event.target));
})();
